import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import Check from '../../svg/check';

class SentOrderModal extends React.Component {

  static propTypes = {
    close: PropTypes.func,
    registerNew: PropTypes.func,
    title: PropTypes.string.isRequired,
    translations: PropTypes.array.isRequired,
    registerButtonText: PropTypes.string.isRequired,
    doneButtonText: PropTypes.string.isRequired
  };

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen
        onRequestClose={this.props.close}>
        <div className='modal-content'>
          <div>
            <h2><Translate content={this.props.title} /></h2>
            <div className='steps-wrapper'>
              <div className='steps'>
                <div className='step checked'>
                  <div className='checkbox-step checked first'>
                    <Check
                      width='15'
                      height='15'
                      colorSchema='white'
                      classes='sent-modal-checkicon'
                    />
                  </div>
                  <Translate content={this.props.translations[0]} />
                </div>
                <div className='step-line'></div>
                <div className='step'>
                  <div className='checkbox-step'></div>
                  <Translate content={this.props.translations[1]} />
                </div>
                <div className='step-line'></div>
                <div className='step'>
                  <div className='checkbox-step last'></div>
                  <Translate content={this.props.translations[2]} />
                </div>
              </div>
            </div>
          </div>
          <div className='sent-modal-btn-wrapper'>
            <button className='btn btn-outline-primary' onClick={this.props.registerNew}>
              <Translate content={this.props.registerButtonText} />
            </button>
            <button className='btn px-30' onClick={this.props.close}>
              <Translate content={this.props.doneButtonText} />
            </button>
          </div>
        </div>
      </Modal>
    );
  }

}

export default SentOrderModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/sent-order-modal/sent-order-modal.js
 **/